/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
// import axios from 'axios';
// import axios from 'axios';
// const BASE_URL = 'http://localhost:3000/local/genome-solidify-api-svc/';
import $http from '../plugins/axios';

const getPreSignedUrl = async (url: any, data: any) => {
  // let preSignedurl;
  // await $http.post(url, data).then((r: any) => {
  //   console.log('prsigned Response', r);
  //   preSignedurl = r.data;
  //   return preSignedurl;
  // });
  // return preSignedurl;
  const preSignedurl = await $http.post(url, data);
  return preSignedurl;
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
// eslint-disable-next-line consistent-return
const uploadSubmission = async (url: any, learnerFile: any) => {
  let uploadResponse;
  const res = await fetch(`${url}`, {
    method: 'put',
    body: learnerFile,
  });
  // eslint-disable-next-line prefer-const
  uploadResponse = res;
  return uploadResponse;
  // const nAxios = axios.create();

  // delete $http.defaults.headers.common.Authorization;
  // await nAxios.put(url, learnerFile).then((res: any) => {
  //   uploadResponse = res;
  //   console.log(`upload learner submission ${JSON.stringify(uploadResponse)}`);
  //   return uploadResponse;
  // });
  // return uploadResponse;
};
const getTaskById = async (taskId: any) => {
  const getTaskres: any = await $http.get(`/task/${taskId}`);
  // getTaskres = response.data.data;
  return getTaskres;
};

const restarLearnerJourney = async (url: any, taskId: any) => {
  // let restartres: any;
  // try {
  //   await $http.post(url, { learner_task_id: taskId }).then((response) => {
  //     restartres = response;
  //     return restartres;
  //   });
  //   return restartres;
  // } catch (error) {
  //   return error;
  // }
  const restartres: any = await $http.post(url, { learner_task_id: taskId });
  // restartres = response;
  return restartres;
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
// eslint-disable-next-line consistent-return
const updateLearnerSubmission = async (url: any, learnerData: any) => {
  // try {
  //   let updateSubmissionRes;
  //   await $http.post(url, learnerData).then((response) => {
  //     updateSubmissionRes = response;
  //     return updateSubmissionRes;
  //   });
  //   return updateSubmissionRes;
  // } catch (error) {
  //   console.log(`Error in updating Learner Submission ${error}`);
  // }
  const updateSubmissionRes = await $http.post(url, learnerData);
  return updateSubmissionRes;
};

const updateGenAISubmission = async (url: any, learnerData: any) => {
  const genAIApiRes = await $http.post(url, learnerData);
  return genAIApiRes;
};

const fetchGenAIResponse = async (url: any, learnerData: any) => {
  return await $http.post(url, learnerData);
};

// eslint-disable-next-line
export { getTaskById, getPreSignedUrl, restarLearnerJourney, uploadSubmission, updateLearnerSubmission, updateGenAISubmission, fetchGenAIResponse };
